//
========================================================================================
// ============= 区属图表 ========================= //
=========================================================================================

<template>
  <div class="Community">
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card class="custom-card">
          <div slot="header" class="clearfix">
            <span>出行服务</span>
          </div>
          <div id="chartTravel" style="width: 100%; height: 300px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="custom-card">
          <div slot="header" class="clearfix">
            <span>走访慰问</span>
          </div>
          <div id="chartVisit" style="width: 100%; height: 300px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card class="custom-card">
          <div slot="header" class="clearfix">
            <span>特殊医疗用药</span>
          </div>
          <div id="chartMedication" style="width: 100%; height: 300px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="custom-card">
          <div slot="header" class="clearfix">
            <span>精神慰藉</span>
          </div>
          <div id="chartSpiritual" style="width: 100%; height: 300px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";

let commOption = {
  legend: {},
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      crossStyle: {
        color: "#999",
      },
    },
  },
  dataset: {
    // 提供一份数据。
    source: [],
  },
  // 声明一个 X 轴，类目轴（category）。默认情况下，类目轴对应到 dataset 第一列。
  xAxis: {
    type: "category",
    axisLabel: {
      formatter: "{value} 月",
    },
  },
  // 声明一个 Y 轴，数值轴。
  yAxis: [{}, {}],
  // 声明多个 bar 系列，默认情况下，每个系列会自动对应到 dataset 的每一列。
  series: [
    { name: "人次", type: "bar", yAxisIndex: 0 },
    { name: "金额", type: "line", yAxisIndex: 1 },
  ],
};

export default {
  name: "Community",
  props: {
    year: [String, Number],
  },
  watch: {
    year() {
      this.fetchData();
    },
  },
  data() {
    return {
      belongname: "区属",

      //出行服务
      chartTravel: null,
      optionT: Object.assign({}, commOption),
      //走访慰问
      chartVisit: null,
      optionV: Object.assign({}, commOption),
      //特殊医疗用药
      chartMedication: null,
      optionM: Object.assign({}, commOption),
      //  精神慰藉
      chartSpiritual: null,
      optionS: Object.assign({}, commOption),
    };
  },
  mounted() {
    this.init();
    this.fetchData();
  },
  methods: {
    init() {
      // 初始化图表
      //   出行
      this.chartTravel = echarts.init(document.getElementById("chartTravel"));
      this.chartTravel.setOption(this.optionT);
      // 走访
      this.chartVisit = echarts.init(document.getElementById("chartVisit"));
      this.chartVisit.setOption(this.optionV);
      // 特殊医疗用药
      this.chartMedication = echarts.init(
        document.getElementById("chartMedication")
      );
      this.optionM.xAxis.axisLabel. formatter="{value}";
      this.chartMedication.setOption(this.optionM);
      // 精神慰藉
      this.chartSpiritual = echarts.init(
        document.getElementById("chartSpiritual")
      );
      this.chartSpiritual.setOption(this.optionS);

      window.addEventListener("resize", () => {
        this.chartTravel.resize();
        this.chartVisit.resize();
        this.chartMedication.resize();
        this.chartSpiritual.resize();
      });
    },

    //获取数据并填充图表
    fetchData() {
      //出行服务
      this.fetchTravelInformation(this.chartTravel, "0101");
      //走访慰问
      this.fetchVisitInformation(this.chartVisit, "03");
      //特殊医疗用药
      this.fetchSpecialMedicalInformation(this.chartMedication, "0201");
      //心理慰藉
      this.fetchDetailInformation(this.chartSpiritual, "0103");
    },

    //  获取出行服务信息（月份，人次，金额）
    fetchTravelInformation(chart, code) {
      this.$axios
        .get(
          "/dashboard/TravelInformation/" +
            code +
            "/" +
            this.belongname +
            "/" +
            this.year
        )
        .then((response) => {
          const { data } = response;
          let result = data;
          if (!result) {
            result = [];
          }
          this.setData(chart, result);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //  获取详细服务信息（月份，人次，金额）
    fetchDetailInformation(chart, code) {
      console.log(this.year);
      this.$axios
        .get(
          "/dashboard/DetailInformation/" +
            code +
            "/" +
            this.belongname +
            "/" +
            this.year
        )
        .then((response) => {
          const { data } = response;
          let result = data;
          if (!result) {
            result = [];
          }
          this.setData(chart, result);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //  获取走访慰问服务信息（月份，人次，金额）
    fetchVisitInformation(chart, code) {
      console.log(this.year);
      this.$axios
        .get(
          "/dashboard/VisitInformation/" +
            code +
            "/" +
            this.belongname +
            "/" +
            this.year
        )
        .then((response) => {
          const { data } = response;
          let result = data;
          if (!result) {
            result = [];
          }
          this.setData(chart, result);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //  获取特殊医疗用药服务信息（月份，人次，金额）
    fetchSpecialMedicalInformation(chart, code) {
      console.log(this.year);
      this.$axios
        .get(
          "/dashboard/SpecialMedicalInformation/" +
            code +
            "/" +
            this.belongname +
            "/" +
            this.year
        )
        .then((response) => {
          const { data } = response;
          let result = data;
          if (!result) {
            result = [];
          }
          this.setData(chart, result);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setData(chart, source) {
      let option = {
        dataset: {
          source: source,
        },
      };
      setTimeout(chart.setOption(option), 500);
    },
  },
};
</script>

<style lang="scss">
.Community {
  width: 100%;
  height: auto;
}
</style>
